<template>
  <div class="mt-4">
    <template v-if="getShowButton">
      <route-place :place="place" />
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import RoutePlace from './RoutePlace'

export default {
  components: {
    RoutePlace
  },
  props: {
    place: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      getShowButton: 'drawer/getIsShowButton'
    })
  }
}
</script>
